import { useContext } from 'react';
import { MapSearchContext } from './MapSearchContext.js';
import { Svg } from '../common/Svg.js';
import * as MapSearchUtils from './MapSearchUtils.js';
import { LightBoxWrapper } from '../common/LightBoxWrapper.js';
import EFS from '../../../images/donor-map/filter-point-efs.svg';
import Match from '../../../images/donor-map/filter-point-match.svg';
import Almost from '../../../images/donor-map/filter-point-almost.svg';
import { MapToggleButton } from './MapToggleButton.js';

const Toggle = ({resultFilters, fieldName, title, image, setResultFilters, children}) => {
    const onClick = () => {
        const newResultFilters = {...resultFilters};
        newResultFilters[fieldName] = !newResultFilters[fieldName];

        setResultFilters(newResultFilters);
    }


    return (
        <div className={`${fieldName}`}>
            <a className={`filter-box ${resultFilters[fieldName] && 'selected'}`} onClick={onClick}>
                {children}
            </a>
        </div>
    )
}

/**
 * Widgets that let you toggle specific filters in map-search.
 */
const MapSearchOptions = ({ resultFilters, setResultFilters}) => {
    return (
        <div className="map-filter-toggles">
            <Toggle resultFilters={resultFilters} setResultFilters={setResultFilters} fieldName="matchOffers" title="Match offers" image="Match">
                <div className="filter-image">
                    <Match/>
                </div>
                <div className={`filter-description`}>
                    <div className="title">Matched donations</div>
                    <p>Find requests with matched donations to make your gift go even further.</p>
                </div>
            </Toggle>
            <Toggle resultFilters={resultFilters} setResultFilters={setResultFilters} fieldName="lowCostOnly" title="Almost funded" image="Almost">
                <div className="filter-image">
                    <Almost/>
                </div>
                <div className={`filter-description`}>
                    <div className="title">Almost funded</div>
                    <p>Support classrooms with less than $100 to complete the request.</p>
                </div>
            </Toggle>
            <Toggle resultFilters={resultFilters} setResultFilters={setResultFilters} fieldName="equityFocus" title="Equity focus" image="EFS">
                <div className="filter-image">
                    <EFS/>
                </div>
                <div className={`filter-description`}>
                    <div className="title">Equity focus</div>
                    <p>Support projects in historically underfunded schools.</p>
                </div>
            </Toggle>
            <MapToggleButton />
        </div>
    );
}

export const DesktopMapSearchOptions = ({selectedMarker, isMobile}) => {
    const context = useContext(MapSearchContext);

    if (selectedMarker || isMobile) {
        return null;
    }

    return (
        <div className="filter-section">
            <h4>Filter by:</h4>
            <MapSearchOptions
                resultFilters={context.resultFilters}
                setResultFilters={context.setResultFilters}
            />
        </div>
    );
}

export const MobileMapSearchOptions = ({filterCount, selectedMarker, isMobile, isSearchOptionsOpen, setSearchOptionsOpen}) => {
    const context = useContext(MapSearchContext);

    if (selectedMarker || !isMobile) {
        return null;
    }

    if (isSearchOptionsOpen) {
        const unmount = () => { setSearchOptionsOpen(false); };
        return (
            <LightBoxWrapper additionalClasses="mobile-modal filter-section" unMountHandler={unmount}>
                <h3>Add a filter</h3>
                {/*TODO For (probably accidental?) useEffect reasons, setting a filter here closes this lightbox. But
                    toggling show-essentials-lists-only does not. We might want to explicitly support this "close on
                    click" behavior and pass unmount into MapSearchOptions here. */}
                <MapSearchOptions
                    resultFilters={context.resultFilters}
                    setResultFilters={context.setResultFilters}
                />
            </LightBoxWrapper>
        );
    } else {
        return (
            <button className={`button-primary small filter-button`} onClick={() => setSearchOptionsOpen(!isSearchOptionsOpen)}>
                Filter {filterCount > 0 ? <div className='filters-applied'>{filterCount} applied</div> : ''}
            </button>
        );
    }

}
